import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormControl, Validators, } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of, Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServicePathsSettings } from '../../configuration/service-paths-settings';
import { UrlSettingsCore } from '../../configuration/url-settings-core';
import { HelpersService } from '../../services/helpers.service';
import { UserManager } from '../../services/user-manager';
import { ViewManagerService } from "../../services/view-manager-service";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  title = 'teleforum-fe-mobile';
  loginForm: FormGroup;
  loading = false;
  subscriptionUserLogged: Subscription;
  msgErrorUsername: string;
  msgErrorPassword: string;
  msgError: string;
  loginSso: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: HelpersService,
    private userManager: UserManager,
    private viewManager: ViewManagerService
  ) {
    /*this.subscriptionUserLogged = this.userManager.getUserLogged().subscribe(isLogged => {
      if (isLogged) {
        this.router.navigate([UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD]);
      }
    });*/
    this.loginSso = environment.sso;
    this.loginForm = new FormGroup({
      username: new UntypedFormControl('', [Validators.required]), // , this.checkName.bind(this)]),
      password: new UntypedFormControl('', [Validators.required]), // , this.checkPassword.bind(this)]),
    });
  }

  ngOnInit() {
    if (this.userManager.isLogged()) {
      this.userManager.sendUserLogged(true);
      this.router.navigate([UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD]);
    } else {
      if (this.loginSso) {
        this.commonService.getLoggedUserData().subscribe((response) => {
          if (response) {
            this.userManager.sendUserLogged(true);
            this.router.navigate([
              UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD,
            ]);
          }
        });
      }
    }
  }

  checkName(control: UntypedFormControl) {
    const username = control.value;
    if (username !== '') {
      if (control.value && control.value.length <= 3) {
        this.msgErrorUsername =
          'Errore: la username deve avere più di 3 caratteri!';
        return { errorUsername: true };
      } else {
        return null;
      }
    }
    return { errorUsername: true };
  }

  checkPassword(control: UntypedFormControl) {
    const password = control.value;
    if (password !== '') {
      if (password.length < 6) {
        this.msgErrorPassword =
          'Errore: la password deve contenere almeno 6 caratteri!';
        return { errorPassword: true };
      }
      if (password === this.loginForm.getRawValue().username) {
        this.msgErrorPassword =
          'Errore: la password deve essere differente dallo username!';
        return { errorPassword: true };
      }
      let re = /[0-9]/;
      if (!re.test(password)) {
        this.msgErrorPassword =
          'Errore: la password deve contenere almeno  un numero (0-9)!';
        return { errorPassword: true };
      }
      re = /[a-z]/;
      if (!re.test(password)) {
        this.msgErrorPassword =
          'Errore: la password deve contenere almeno una lettera minuscola (a-z)!';
        return { errorPassword: true };
      }
      return null;
    }
    return { errorPassword: true };
  }

  onSubmit() {
    this.msgError = '';
    const user = this.loginForm.getRawValue().username;
    localStorage.setItem('TLF_USER', user);
    //localStorage.setItem('TLF_SDOMAIN', '.rete.poste');
    localStorage.setItem('TLF_TENANT', '');
    this.userManager.sendUserLogged(true);
    this.router.navigate([UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD]);
  }

  onSubmitOld(count = 1) {
    this.msgError = '';
    if (count <= 3) {
      // 3 tentativi in caso di response 403 JSESSIONID non valido
      count = count + 1;
      let user;
      user = this.loginForm.getRawValue().username;
      this.viewManager.resetCacheDescrittori();
      this.commonService
        .loginSSO(user, this.loginForm.getRawValue().password)
        .subscribe(
          () => {
            localStorage.setItem('TLF_USER', user);
            //localStorage.setItem('TLF_SDOMAIN', '.rete.poste');
            localStorage.setItem('TLF_TENANT', '');
            // this.userManager.sendUserLogged(!!res);
            this.userManager.sendUserLogged(true);
            this.userManager.afterToken().subscribe(res => {
              if(res){
               this.router.navigate([
                UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD,
              ]);
              }
            })

          },
          (error) => {
            if (error.status === 0) {
              this.msgError = 'Not connected Verify Network.';
            } else if (error.status === 403) {
              this.onSubmitOld(count);
              this.msgError = 'Login failed. [403]';
            } else if (error.status === 404) {
              this.msgError = 'Requested page not found. [404]';
            } else if (error.status === 500) {
              this.msgError = 'Internal Server Error [500].';
              /*} else if (exception === 'parsererror') {
            this.msgError = 'Requested JSON parse failed.';
          } else if (exception === 'timeout') {
            this.msgError = 'Time out error.';
          } else if (exception === 'abort') {
            this.msgError = 'Ajax request aborted.';*/
            } else {
              this.msgError = 'Uncaught Error. ' + error.responseText;
            }
          }
        );
        this.commonService.logInReportSSO(user, this.loginForm.getRawValue().password).subscribe(() => {},
        (error)=> {of(false)})
    } else {
      this.msgError = 'effettuati più di 3 tentativi';
    }
  }

  goSAML() {
    window.location.href =
      ServicePathsSettings.DOMINIO + '/' + UrlSettingsCore.URL_SSO;
  }
}
